import { api } from './client';

/**
 * Series generate-from-chats — propose only.
 * Accept writes through book-board and series-snapshots.
 */
export const seriesOffersApi = {
  propose: (projectId, { sessionIds = [], batchIds = [] } = {}) => (
    api.post(`/projects/${projectId}/series-offers/propose`, {
      session_ids: sessionIds,
      batch_ids: batchIds,
    })
  ),
};
